module.exports = __webpack_public_path__ + "static/media/img-institucion.5321d4a9.svg";